import "./footer.css";
const currentYear = new Date().getFullYear();

const Footer = () => {   

  return (
    <footer className="footer">
      <p className="footer-bottom">
        Designed & Developed by{" "}
        <a
          href="https://www.ekathvainnovations.com/index"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ekathva Innovations
        </a>
        <br />
        ©{currentYear} All Rights Reserved.
      </p>
    </footer>
  );
};

export default Footer;
